import Link from "next/link";

function global_reference({ blok }) {

  const items = blok?.reference?.filter(item => item.name == "Footer")?.[0]?.content?.global?.[0]?.items || [];
  const footerbottom = blok?.reference?.filter(item => item.name == "Footer")?.[0]?.content?.global?.[0]?.FooterBottom?.[0] || [];

  const col1 = items?.find(item => item.component == "FooterColumn1");
  const col2 = items?.find(item => item.component == "FooterColumn2");
  const cols = items?.filter(item => item.component == "FooterGenericItem");

  // Adding the gradient animation keyframes as inline style
  const footerStyles = `
    @keyframes gradientFlow {
  0% {
    background-position: 100% 50%; /* Start from right */
  }
  100% {
    background-position: 0% 50%; /* Move to left */
  }
}
  `;

  return (
    <footer
      className="text-white py-12 lg:mt-0 footer w-full" 
      style={{
        background: `linear-gradient(
          90deg,
          #672C7B 0%,    /* Start with dark purple */
          #6D2F80 15%,   /* Intermediate soft purple */
          #493989 35%,   /* Shift to deep blue-purple */
          #4E3C92 50%,   /* Smooth blue transition */
          #493989 65%,   /* Keep consistency in blue-purple */
          #6D2F80 85%,   /* Return to soft purple */
          #672C7B 100%   /* End with dark purple */
        )`,
        backgroundSize: "800% 100%", // Makes the gradient wider than the container
        animation: "gradientFlow 15s linear infinite",
      }}
    >
      {/* Injecting the keyframes in a <style> tag */}
      <style>{footerStyles}</style>

      <div className="mx-auto lg:px-0 px-4 max-w-7xl">
        {/* Footer Main Section */}
        <div className="grid lg:grid-cols-5 gap-8 mb-12 lg:mx-24 2xl:mx-0">
          {/* Logo and Description Section */}
          <div>
            <a href="/">
              <img
                src={col1?.image?.filename}
                alt={col1?.image?.alt}
                className="h-8 mb-10"
              />
            </a>
            <p className="text-[16px] mb-10">{col1.text}</p>

            {/* Social Media Links */}
            <div className="flex mb-[-58px]">
              {col1?.sociallinks?.map((item, index) => {
                return <a
                  key={index}
                  href={item?.url?.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="lg:w-24 lg:h-24 ml-[-20px]"
                >
                  <img
                    src={item?.image?.filename}
                    alt={item?.image?.alt}
                  />
                </a>
              })}

            </div>
          </div>

          {/* Contact Info Section */}
          <div>
            <h4 className="text-lg font-bold mb-4">{col2.title}</h4>
            <p className="text-sm">
              {"2440 Louisiana Blvd NE"} <br /> {" #560, Albuquerque, NM"}{" "}
              <br /> {"87110"}
            </p>
            <br />
            <Link href={`tel:+${col2.phone}`} className="text-sm">{col2.phone}</Link>
            <br />
            <Link href={`mailto:${col2.email}`} className="text-sm hover:text-gray-300">
              {col2.email}
            </Link>
          </div>

          {/* Solutions Section */}
          {cols.map((item, index) => {
            return <div key={index}>
              <h4 className="text-lg font-bold mb-4">{item.Title}</h4>
              <ul>
                {item.FooterLinks.map((item, index) => {
                  return <li className="pb-2" key={index}>
                    <a
                      href={"/"+item.url.cached_url}
                      // onClick={() => {
                      //   navigate(item.url.url);
                      //   window.scrollTo(0, 0);
                      // }}
                      className="text-sm hover:text-gray-300 cursor-pointer"
                    >
                      {item.text}
                    </a>
                  </li>
                })}
              </ul>
            </div>
          })}
        </div>

      </div>
      {/* Divider */}
      <hr className="border-t border-white my-8" />

      {/* Footer Bottom Section */}
      <div className="flex justify-center">
        <div className="flex flex-col lg:flex-row lg:justify-between lg:items-center self-center max-w-7xl w-full px-4 lg:px-0">
          {/* Copyright */}
          <p className="text-[10px] lg:text-sm">
            {footerbottom?.copyright}
          </p>

          {/* Legal Links */}
          <div className="lg:flex gap-4 mt-6 lg:mt-0 lg:space-x-6">
            {footerbottom?.links?.map((item, index) => {
              return <div key={index}>
                <a
                  href={"/"+item?.url?.cached_url}
                  className="text-[10px] lg:text-sm hover:text-gray-300 cursor-pointer"
                >
                  {item.text}
                </a>
              </div>
            })}

          </div>
        </div>
      </div>
    </footer>
  );
}

export default global_reference;
